import { AxiosResponse } from "axios";

import { VITE_TENANT_ORION } from "@/constants";
import { axiosInstanceOrion } from "@/service/Axios";

import { OrionV2AuthenticateResponseT } from "./orionv2.types";

export const isOrionAuthenticateRequest = (requestUrl?: string): boolean => {
  return requestUrl?.includes("/business/authenticate") ?? false;
};

export const postOrionAuthenticate = async (
  legacyToken: string,
): Promise<OrionV2AuthenticateResponseT> => {
  const TENANT = VITE_TENANT_ORION;
  const token = `Bearer ${legacyToken}`;

  return await axiosInstanceOrion
    .post<unknown, AxiosResponse<OrionV2AuthenticateResponseT>>(
      `/v1/securitycore/authentication/business/authenticate`,
      undefined,
      {
        headers: {
          "X-Tenant": TENANT,
          Authorization: token,
        },
      },
    )
    .then((r) => r.data);
};
